import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import {
  Button,
  IconButton,
  Tooltip,
  DialogContent,
  Dialog,
  DialogActions,
  TextField,
} from "@mui/material";
import { Checkbox, FormControlLabel, Typography, Box } from "@mui/material";
import { toast } from "react-toastify";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { Close, FlagCircleTwoTone } from "@mui/icons-material";
import Axios from "../axios";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { CSVLink, CSVDownload } from "react-csv";
import { useParams, useLocation } from "react-router-dom";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import UserRoleListing from "./userRoleManagement";
import DownloadIcon from "@mui/icons-material/Download";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { useAuth } from "../auth/authContext";
import { Helmet } from "react-helmet";

const RoleListing = () => {
  const pages = [
    "Dashboard",
    "About Us",
    "Slice and Dice",
    "Arrival List",
    "Booking List",
    "Daily Transaction",
    "User Management",
    "News Room",
    "Trip Listing",
    "FAQ Management",
    "Subscription",
    "Privacy and Policy",
    "Terms and Condition",
    "Flodesk",
    "Role Management",
    "Featured Hotels",
    "Affiliates",
    "Detailed View",
    "Market",
  ];

  const location = useLocation();
  const [open, setOpen] = useState(false);
  const { navData } = useAuth();
  const [opendel, setOpenDel] = useState(false);
  const [id, setID] = useState();
  const [role, setRole] = useState();
  const [roleName, setRoleName] = useState("");
  const [permissions, setPermissions] = useState(
    pages.map((page) => ({
      page,
      read: false,
      write: false,
    }))
  );
  const [allTrip, setAllTrip] = useState();

  const [type, setType] = useState("");
  const [page, setPage] = useState(0);
  const [count, setCount] = useState();
  const [search, setSearch] = useState("");
  const { passedValue } = location?.state || {};
  const [value, setValue] = React.useState("1");
  const [write, setWrite] = useState(false);
  //data for the CSV file
  const [downloadData, setDownloadData] = useState([]);
  //header for the CSv file
  const headers = [
    { label: "Trip Name", key: "tripName" },
    { label: "User Name", key: "userName" },
    { label: "Created Date", key: "createdAt" },
    { label: "Feature Status", key: "featureuserStatus" },
    { label: "Explore Status", key: "exploreuserStatus" },
  ];

  useEffect(() => {
    fetchAllRoles(0, "", "");
  }, []);
  useEffect(() => {
    const currentPath = location.pathname;
    const matchingNavItem = navData.find((item) => item.link === currentPath);
    if (matchingNavItem) {
      setWrite(matchingNavItem.write);
    } else {
      setWrite(false);
    }
  }, [location.pathname, navData]);
  const fetchAllRoles = (page, search, id) => {
    let data = {
      page: page,
      searchChar: search,
      userID: id,
    };

    Axios.post(process.env.REACT_APP_BACKEND + "get-roles", data)
      .then((resp) => {
        setAllTrip(resp?.data?.data);
        setCount(resp?.data?.data?.totalDocs);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  //-----------------------Start--Role access[To Set the Check Box State]-------------------------------------------------
  const handleCheckboxChange = (page, type) => {
    setPermissions((prev) =>
      prev.map((p) => (p.page === page ? { ...p, [type]: !p[type] } : p))
    );
  };
  //-----------------------End--Role access[To Set the Check Box State]-------------------------------------------------

  const handleDelete = () => {
    let data = {
      id: id,
    };
    Axios.post(process.env.REACT_APP_BACKEND + "delete-role", data)

      .then((resp) => {
        setAllTrip(resp?.data?.data);
        setCount(resp?.data?.data?.totalDocs);
        toast.success(resp && resp.data && resp.data.message);
        handleClose();
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };
  //-------------option for the mui table----------------------------
  const options = {
    responsive: "standard",
    selectableRows: "none",
    filter: false,
    viewColumns: false,
    serverSide: true,
    rowsPerPageOptions: [],
    count: count,
    page,
    download: false,
    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        fetchAllRoles(tableState.page, search);
        setPage(tableState.page);
      }
    },
    onSearchChange: (searchText) => {
      fetchAllRoles(page, searchText);
      setSearch(searchText);
    },
    customToolbar: () => (
      <>
        <Tooltip title="Download">
          <IconButton>
            <CSVLink
              data={downloadData}
              headers={headers}
              filename={"trip.csv"}
            >
              <DownloadIcon />
            </CSVLink>
          </IconButton>
        </Tooltip>
      </>
    ),
  };

  const columns = [
    {
      name: "role",
      label: "Role",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return <>{allTrip[dataIndex]?.role}</>;
        },
      },
    },

    write && {
      name: "options",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <Tooltip title="Edit">
                <IconButton
                  aria-label="Edit FAQ"
                  onClick={() => handleOpen(allTrip[dataIndex], "edit")}
                >
                  <EditOutlinedIcon className="icon-size" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete">
                <IconButton
                  aria-label="Delete FAQ"
                  onClick={() => handleOpen(allTrip[dataIndex]._id, "delete")}
                >
                  <DeleteOutlineOutlinedIcon className="red-color fs-16 icon-size" />
                </IconButton>
              </Tooltip>
            </>
          );
        },
      },
    },
  ].filter(Boolean);

  // Function for dialog open close
  const handleOpen = (data, type) => {
    if (type === "edit") {
      setOpen(true);
      setPermissions(data?.permissions);
      setRoleName(data?.role);
      setType(type);
      setID(data?._id);
    } else if (type === "delete") {
      setID(data);
      setOpenDel(true);
    } else {
      setOpen(true);
    }
  };
  const handleClose = () => {
    setType("");
    setOpen(false);
    setOpenDel(false);
    setRoleName("");
    setID("");
    setPermissions(
      pages.map((page) => ({
        page,
        read: false,
        write: false,
      }))
    );
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === "1") {
      if (passedValue) {
        fetchAllRoles(0, "", passedValue);
        setPage(0);
      } else {
        fetchAllRoles(0, "", "");
        setPage(0);
      }
    }
  };

  const handleSubmit = () => {
    let api;
    let data;
    if (type === "edit") {
      api = "update-read-write";
      data = {
        id: id,
        role: roleName,
        permissions: permissions,
      };
    } else {
      api = "create-roles";
      data = {
        role: roleName,
        permissions: permissions,
      };
    }

    Axios.post(process.env.REACT_APP_BACKEND + api, data)
      .then((resp) => {
        setAllTrip(resp?.data?.data);
        setCount(resp?.data?.data?.totalDocs);
        toast.success(resp && resp.data && resp.data.message);
        handleClose();
      })
      .catch((err) => {
        toast.error(err && err.message);
      });
  };
  return (
    <>
      <Helmet>
        <title>Sevenly-Role</title>
        <meta name="Trip List" content="Trip List for Home Page" />
      </Helmet>
      <h1 className="mb--12 sevenly-cursor"> — </h1>
      <div className="d-flex justify-content-between mb-2">
        <h2>Role Management</h2>
      </div>
      <div className="d-flex justify-content-between mb-2">
        <Tabs
          value={value}
          onChange={handleChange}
          className="mb-4"
          sx={{
            "& button": {
              borderRadius: 2,
              color: "#000",
              transition: "all 0.3s",
            },
            "& button:hover": {
              color: "#3dd2cc",
            },
            "& button.Mui-selected": {
              color: "#3dd2cc",
              fontWeight: "bold",
            },
            "& .MuiTabs-indicator": {
              backgroundColor: "black",
            },
          }}
        >
          <Tab className="fs-14 fw-600 p-2 mr-2" value="1" label="Role" />
          <Tab className="fs-14 fw-600 p-2 mr-2" value="2" label="User" />
        </Tabs>
      </div>
      {value === "1" ? (
        <>
          <div className="d-flex justify-content-end mb-2">
            {write ? (
              <Button
                className="w7 sevenly-btn text-white"
                onClick={handleOpen}
              >
                Add
              </Button>
            ) : (
              <></>
            )}
          </div>
          <MUIDataTable
            title={"Role List"}
            data={allTrip}
            columns={columns}
            options={options}
          />
        </>
      ) : value === "2" ? (
        <UserRoleListing />
      ) : (
        <></>
      )}

      {/* ------------------------------Create Trip Section ---------------------------------------- */}
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        open={open}
      >
        <div className="d-flex justify-content-between align-center p-3">
          <h3>Role Details</h3>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          <TextField
            label="Role"
            variant="outlined"
            fullWidth
            onChange={(e) => setRoleName(e.target.value)}
            className="my-2"
            placeholder="Enter Role"
            name="role"
            value={roleName}
          />
          <Box>
            {pages.map((page) => {
              const permission = permissions.find((p) => p.page === page) || {};
              return (
                <Box key={page} sx={{ marginBottom: 2 }}>
                  <Typography variant="h6">{page}</Typography>
                  <Box display="flex" alignItems="center">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={permission.read || false}
                          onChange={() => handleCheckboxChange(page, "read")}
                          color="primary"
                        />
                      }
                      label="Read"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={permission.write || false}
                          onChange={() => handleCheckboxChange(page, "write")}
                          color="primary"
                        />
                      }
                      label="Write"
                    />
                  </Box>
                </Box>
              );
            })}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
          <Button
            className="submit-button"
            variant="contained"
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        open={opendel}
      >
        <div className="d-flex justify-content-between align-center p-3">
          <h3>Delete Role</h3>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          <p className="fs-14">
            {"Are you sure you want to delete the Role ?"}
          </p>
        </DialogContent>
        <DialogActions>
          <Button className="cancel-button" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            className="submit-button"
            variant="contained"
            onClick={handleDelete}
          >
            {"Delete"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default RoleListing;
